import type { Category } from '../types/api';
import './Categories.css';

interface Props {
  categories: Category[];
  selectedId: string | null;
  onSelect: (category: Category | null) => void;
}

export default function Categories({ categories, selectedId, onSelect }: Props) {
  const allSelected = selectedId === null;

  return (
    <section className="categories section-shell">
      <div className="categories-header">
        <div>
          <h2>Categorias</h2>
          <p>Filtre por segmento real sincronizado do SOFTMOBILE.</p>
        </div>
      </div>
      <div className="categories-scroll" role="tablist" aria-label="Categorias de produtos">
        <button
          className={`category-chip${allSelected ? ' category-chip--active' : ''}`}
          type="button"
          aria-pressed={allSelected}
          onClick={() => onSelect(null)}
        >
          Todos
        </button>
        {categories.map(cat => {
          const isActive = cat.id === selectedId;
          return (
            <button
              key={cat.id}
              className={`category-chip${isActive ? ' category-chip--active' : ''}`}
              type="button"
              aria-pressed={isActive}
              onClick={() => onSelect(isActive ? null : cat)}
            >
              {cat.name}
            </button>
          );
        })}
      </div>
    </section>
  );
}
